import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Fade from "@mui/material/Fade";
import { store } from "../../../../utils/store";

export default function LongMenu(props: any) {
  const privileges = store.getState().auth?.privileges || {};
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {privileges &&
        (privileges?.["Project List"]?.includes("view") ||
          privileges?.["Project List"]?.includes("full control")) ? (
          <>
            <MenuItem
              sx={{ fontSize: "12px" }}
              onClick={() => {
                handleClose();
                props.handleEdit(props.idd, props?.data);
              }}
            >
              Edit
            </MenuItem>
            {props.handleUpdatePricing ? (
              <MenuItem
                sx={{ fontSize: "12px" }}
                onClick={() => {
                  handleClose();
                  props.handleUpdatePricing(props.idd, props?.data);
                }}
              >
                Update Pricing
              </MenuItem>
            ) : null}
          </>
        ) : (
          ""
        )}
        {props.handelShare ? (
          <MenuItem
            sx={{ fontSize: "12px" }}
            onClick={() => {
              handleClose();
              props.handelShare();
            }}
          >
            Share
          </MenuItem>
        ) : (
          ""
        )}
      </Menu>
    </div>
  );
}
